import ReceiptViewGatewayInterface from '../../domain/Receipt/ReceiptViewGatewayInterface'
import {ReceiptView, ReceiptViewGroupedByScope, ReceiptViewInterface} from '../../domain/Receipt/ReceiptView'
import Caller from '../../domain/Api/Caller'
import envVariable from '../../presentation/util/envVariable'
import { SubscriberScopeEnum } from '../../domain/CustomerInfoRecall/SubscriberScopeEnum'


export default class ReceiptViewGateway implements ReceiptViewGatewayInterface {
  async retrieveList(dossierId: string): Promise<ReceiptViewGroupedByScope | null> {
    const data = await Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossiers/${dossierId}/receipts`, {})
    if (!data) {
      return null;
    }

    const allReceipts: ReceiptViewInterface[] = Object.values<ReceiptViewInterface>(data).flat();
    const receipts: ReceiptViewGroupedByScope = allReceipts.reduce<ReceiptViewGroupedByScope>((acc, receipt) => {
      const scopeKey = receipt.scope || SubscriberScopeEnum.UNDEFINED;
      const typeKey = receipt.type
      if (!acc[scopeKey]) {
        acc[scopeKey] = {};
      }
      if (!acc[scopeKey][typeKey]) {
        acc[scopeKey][typeKey] = [];
      }

      acc[scopeKey][typeKey].push(new ReceiptView(
        receipt.id,
        receipt.elementId,
        receipt.title,
        receipt.type,
        receipt.signedDocument,
        receipt.scope,
        receipt.receiptTypeId
      ));
      return acc;
    }, {});

    return receipts
  }
}
